/* eslint-disable sonarjs/no-redundant-assignments */

let environment = 'local';
let authServerUrl = 'http://localhost:10079/rest';
let claimServerUrl = 'http://localhost:10081/rest';
let orderServerUrl = 'http://localhost:10082/rest';
let offerServerUrl = 'http://localhost:10086/rest';
let apiSalesdocServerUrl = 'http://localhost:10083/rest';
let portalServerUrl = 'http://localhost:10085/rest';
let aqdbServerUrl = 'http://localhost:10088/rest';
let	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
let oldSteelUserUrl = 'http://localhost:9080';
let redirectUri = `${ location.origin }/redirect`;
let buildNumber = '1.0.0L.7c6674f5';
let aiKey = 'ce531264-6d7a-40a5-a64e-42ca2c1c087f';
let aiEndpoint = 'https://westeurope-0.in.applicationinsights.azure.com/v2/track';
let { title } = document;

switch (location.origin) {
case 'https://portal.steeluser.com':
	environment = 'production';
	authServerUrl = 'https://auth.steeluser.com/rest';
	claimServerUrl = 'https://claim.steeluser.com/rest';
	orderServerUrl = 'https://order.steeluser.com/rest';
	offerServerUrl = 'https://offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://portal.steeluser.com/rest';
	aqdbServerUrl = 'https://aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '';
	oldSteelUserUrl = 'https://www.steeluser.com';
	redirectUri = 'https://portal.steeluser.com/redirect';
	buildNumber = '1.0.0P.7c6674f5';
	aiKey = 'c80bb6fe-c8b6-4356-bb5c-9d96bb7a9764';
	aiEndpoint = 'https://westeurope-0.in.applicationinsights.azure.com/v2/track';
	break;
case 'https://test-hotfix-portal.steeluser.com':
	environment = 'hotfix';
	authServerUrl = 'https://test-hotfix-auth.steeluser.com/rest';
	claimServerUrl = 'https://test-hotfix-claim.steeluser.com/rest';
	orderServerUrl = 'https://test-hotfix-order.steeluser.com/rest';
	offerServerUrl = 'https://test-hotfix-offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://test-hotfix-api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://test-hotfix-portal.steeluser.com/rest';
	aqdbServerUrl = 'https://test-hotfix-aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
	oldSteelUserUrl = 'https://test-hotfix.steeluser.com';
	redirectUri = 'https://test-hotfix-portal.steeluser.com/redirect';
	buildNumber = '1.0.0H.7c6674f5';
	aiKey = '201682d2-0c15-4d87-a660-2e48bcfb25a8';
	aiEndpoint = 'https://westeurope-0.in.applicationinsights.azure.com/v2/track';
	title = `Hotfix ${ title }`;
	break;
case 'https://test-portal.steeluser.com':
	environment = 'acceptance';
	authServerUrl = 'https://test-auth.steeluser.com/rest';
	claimServerUrl = 'https://test-claim.steeluser.com/rest';
	orderServerUrl = 'https://test-order.steeluser.com/rest';
	offerServerUrl = 'https://test-offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://test-api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://test-portal.steeluser.com/rest';
	aqdbServerUrl = 'https://test-aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
	oldSteelUserUrl = 'https://test.steeluser.com';
	redirectUri = 'https://test-portal.steeluser.com/redirect';
	buildNumber = '1.0.0A.7c6674f5';
	aiKey = '201682d2-0c15-4d87-a660-2e48bcfb25a8';
	aiEndpoint = 'https://westeurope-0.in.applicationinsights.azure.com/v2/track';
	title = `Acceptance ${ title }`;
	break;
case 'https://dev-portal.steeluser.com':
	environment = 'global';
	authServerUrl = 'https://dev-auth.steeluser.com/rest';
	claimServerUrl = 'https://dev-claim.steeluser.com/rest';
	orderServerUrl = 'https://dev-order.steeluser.com/rest';
	offerServerUrl = 'https://dev-offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://dev-api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://dev-portal.steeluser.com/rest';
	aqdbServerUrl = 'https://dev-aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
	oldSteelUserUrl = 'https://web-stu-front-dev-dit.steeluser.com';
	redirectUri = 'https://dev-portal.steeluser.com/redirect';
	buildNumber = '1.0.0G.7c6674f5';
	aiKey = 'ce531264-6d7a-40a5-a64e-42ca2c1c087f';
	aiEndpoint = 'https://westeurope-0.in.applicationinsights.azure.com/v2/track';
	title = `Global ${ title }`;
	break;
case 'https://web-portal-ope-prd.steeluser.com':
	environment = 'production-int';
	authServerUrl = 'https://auth.steeluser.com/rest';
	claimServerUrl = 'https://claim.steeluser.com/rest';
	orderServerUrl = 'https://order.steeluser.com/rest';
	offerServerUrl = 'https://offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://web-portal-ope-prd.steeluser.com/rest';
	aqdbServerUrl = 'https://aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '';
	oldSteelUserUrl = 'https://web-stu-front-ope-prd.steeluser.com';
	redirectUri = 'https://web-portal-ope-prd.steeluser.com/redirect';
	buildNumber = '1.0.0PI.7c6674f5';
	aiKey = 'c80bb6fe-c8b6-4356-bb5c-9d96bb7a9764';
	aiEndpoint = 'https://westeurope-0.in.applicationinsights.azure.com/v2/track';
	break;
case 'https://web-portal-aks-ope-prd.steeluser.com':
	environment = 'production-int-azure';
	authServerUrl = 'https://auth.steeluser.com/rest';
	claimServerUrl = 'https://claim.steeluser.com/rest';
	orderServerUrl = 'https://order.steeluser.com/rest';
	offerServerUrl = 'https://offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://web-portal-aks-ope-prd.steeluser.com/rest';
	aqdbServerUrl = 'https://aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '';
	oldSteelUserUrl = 'https://web-stu-front-ope-prd.steeluser.com';
	redirectUri = 'https://web-portal-aks-ope-prd.steeluser.com/redirect';
	buildNumber = '1.0.0PIA.7c6674f5';
	aiKey = 'c80bb6fe-c8b6-4356-bb5c-9d96bb7a9764';
	break;
case 'https://web-portal-htx-qat.steeluser.com':
	environment = 'hotfix-int';
	authServerUrl = 'https://test-hotfix-auth.steeluser.com/rest';
	claimServerUrl = 'https://test-hotfix-claim.steeluser.com/rest';
	orderServerUrl = 'https://test-hotfix-order.steeluser.com/rest';
	offerServerUrl = 'https://test-hotfix-offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://test-hotfix-api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://web-portal-htx-qat.steeluser.com/rest';
	aqdbServerUrl = 'https://test-hotfix-aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
	oldSteelUserUrl = 'https://web-stu-front-htx-qat.steeluser.com';
	redirectUri = 'https://web-portal-htx-qat.steeluser.com/redirect';
	buildNumber = '1.0.0HI.7c6674f5';
	aiKey = '201682d2-0c15-4d87-a660-2e48bcfb25a8';
	aiEndpoint = 'https://westeurope-0.in.applicationinsights.azure.com/v2/track';
	title = `Hotfix ${ title }`;
	break;
case 'https://web-portal-aks-htx-qat.steeluser.com':
	environment = 'hotfix-int-azure';
	authServerUrl = 'https://test-hotfix-auth.steeluser.com/rest';
	claimServerUrl = 'https://test-hotfix-claim.steeluser.com/rest';
	orderServerUrl = 'https://test-hotfix-order.steeluser.com/rest';
	offerServerUrl = 'https://test-hotfix-offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://test-hotfix-api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://web-portal-aks-htx-qat.steeluser.com/rest';
	aqdbServerUrl = 'https://test-hotfix-aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
	oldSteelUserUrl = 'https://web-stu-front-aks-htx-qat.steeluser.com';
	redirectUri = 'https://web-portal-aks-htx-qat.steeluser.com/redirect';
	buildNumber = '1.0.0HIA.7c6674f5';
	aiKey = '201682d2-0c15-4d87-a660-2e48bcfb25a8';
	title = `Hotfix ${ title }`;
	break;
case 'https://web-portal-acc-qat.steeluser.com':
	environment = 'acceptance-int';
	authServerUrl = 'https://test-auth.steeluser.com/rest';
	claimServerUrl = 'https://test-claim.steeluser.com/rest';
	orderServerUrl = 'https://test-order.steeluser.com/rest';
	offerServerUrl = 'https://test-offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://test-api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://web-portal-acc-qat.steeluser.com/rest';
	aqdbServerUrl = 'https://test-aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
	oldSteelUserUrl = 'https://web-stu-front-acc-qat.steeluser.com';
	redirectUri = 'https://web-portal-acc-qat.steeluser.com/redirect';
	buildNumber = '1.0.0AI.7c6674f5';
	aiKey = '201682d2-0c15-4d87-a660-2e48bcfb25a8';
	aiEndpoint = 'https://westeurope-0.in.applicationinsights.azure.com/v2/track';
	title = `Acceptance ${ title }`;
	break;
case 'https://web-portal-aks-acc-qat.steeluser.com':
	environment = 'acceptance-int-azure';
	authServerUrl = 'https://test-auth.steeluser.com/rest';
	claimServerUrl = 'https://test-claim.steeluser.com/rest';
	orderServerUrl = 'https://test-order.steeluser.com/rest';
	offerServerUrl = 'https://test-offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://test-api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://web-portal-aks-acc-qat.steeluser.com/rest';
	aqdbServerUrl = 'https://test-aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
	oldSteelUserUrl = 'https://web-stu-front-acc-qat.steeluser.com';
	redirectUri = 'https://web-portal-aks-acc-qat.steeluser.com/redirect';
	buildNumber = '1.0.0AIA.7c6674f5';
	aiKey = '201682d2-0c15-4d87-a660-2e48bcfb25a8';
	title = `Acceptance ${ title }`;
	break;
case 'https://web-portal-dev-dit.steeluser.com':
	environment = 'global-int';
	authServerUrl = 'https://dev-auth.steeluser.com/rest';
	claimServerUrl = 'https://dev-claim.steeluser.com/rest';
	orderServerUrl = 'https://dev-order.steeluser.com/rest';
	offerServerUrl = 'https://dev-offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://dev-api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://web-portal-dev-dit.steeluser.com/rest';
	aqdbServerUrl = 'https://dev-aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
	oldSteelUserUrl = 'https://web-stu-front-dev-dit.steeluser.com';
	redirectUri = 'https://web-portal-dev-dit.steeluser.com/redirect';
	buildNumber = '1.0.0GI.7c6674f5';
	aiKey = 'ce531264-6d7a-40a5-a64e-42ca2c1c087f';
	aiEndpoint = 'https://westeurope-0.in.applicationinsights.azure.com/v2/track';
	title = `Global ${ title }`;
	break;
case 'https://web-portal-aks-dev-dit.steeluser.com':
	environment = 'global-int-azure';
	authServerUrl = 'https://dev-auth.steeluser.com/rest';
	claimServerUrl = 'https://dev-claim.steeluser.com/rest';
	orderServerUrl = 'https://dev-order.steeluser.com/rest';
	offerServerUrl = 'https://dev-offer.steeluser.com/rest';
	apiSalesdocServerUrl = 'https://dev-api-salesdoc.steeluser.com/rest';
	portalServerUrl = 'https://web-portal-aks-dev-dit.steeluser.com/rest';
	aqdbServerUrl = 'https://dev-aqdb.steeluser.com/rest';
	n4sShipmentSelectionAllowedMills = '7460,6150,0007,7320';
	oldSteelUserUrl = 'https://web-stu-front-dev-dit.steeluser.com';
	redirectUri = 'https://web-portal-aks-dev-dit.steeluser.com/redirect';
	buildNumber = '1.0.0GIA.7c6674f5';
	aiKey = 'ce531264-6d7a-40a5-a64e-42ca2c1c087f';
	title = `Global ${ title }`;
	break;
default:
	// if steeluser.com and not managed by test above.... reject
	if (location.origin.endsWith('.steeluser.com')) {
		throw new Error('unmanaged steeluser origin: '.concat(location.origin));
	}

	break;
}

if (document.title !== title) {
	document.title = title;
}

export const CLIENT_ID = '7U2EyJ8Xn5UvRPWA';
export const PROD_MODE = <boolean> true;
export const ENVIRONMENT = environment;
export const AUTH_SERVER_URL = authServerUrl;
export const CLAIM_SERVER_URL = claimServerUrl;
export const ORDER_SERVER_URL = orderServerUrl;
export const OFFER_SERVER_URL = offerServerUrl;
export const API_SALESDOC_SERVER_URL = apiSalesdocServerUrl;
export const PORTAL_SERVER_URL = portalServerUrl;
export const AQDB_SERVER_URL = aqdbServerUrl;
export const OLD_STEELUSER_URL = oldSteelUserUrl;
export const N4S_SHIPMENT_SELECTION_ALLOWED_MILLS = n4sShipmentSelectionAllowedMills;
export const AUTH_REQUIRED_URLS = [
	AUTH_SERVER_URL,
	CLAIM_SERVER_URL,
	ORDER_SERVER_URL,
	OFFER_SERVER_URL,
	API_SALESDOC_SERVER_URL,
	PORTAL_SERVER_URL,
	AQDB_SERVER_URL
];
export const REDIRECT_URI = redirectUri;
export const BUILD_NUMBER = buildNumber;
export const APPLICATION_INSIGHTS_KEY = aiKey;
export const APPLICATION_INSIGHTS_ENDPOINT = aiEndpoint;
// eslint-disable-next-line @stylistic/max-len
export const AGGRID_KEY = 'Using_this_AG_Grid_Enterprise_key_( AG-050583 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( ArcelorMittal Flat Carbon Europe S.A. )_is_granted_a_( Single Application )_Developer_License_for_the_application_( Steeluse )_only_for_( 3 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_( Steeluse )_need_to_be_licensed___( Steeluse )_has_been_granted_a_Deployment_License_Add-on_for_( 1 )_Production_Environment___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 30 November 2024 )____[v2]_MTczMjkyNDgwMDAwMA==c95ffe1a4b792cfe20c235040dee5a60';
